module.exports = __webpack_public_path__ + "static/media/thor.13c01258.JPG";